const { withPrefix } = require("gatsby")
const { DEFAULT_LANG } = require("../constants/languages")

module.exports = {
  changeTitleRout: function (item) {
    const auditSchoolName = item.replace(/[^a-z0-9._]+/gi, "-").toLowerCase()

    return auditSchoolName.slice(-1) === "-"
      ? auditSchoolName.slice(0, -1)
      : auditSchoolName
  },

  isBrowser: function () {
    return typeof window !== "undefined"
  },

  getCurrentLang: function () {
    if (typeof window === "undefined") return DEFAULT_LANG
    const paths = window.location.pathname.split("/").filter(Boolean)
    return paths.length > 0 && paths[0].length === 2 ? paths[0] : DEFAULT_LANG
  },

  getImageUrl(value) {
    if (!value) {
      return null;
    }
    return  process.env.PROD !== 'false' ? withPrefix('/files/' + value) : `http://localhost:5080/files/${value}`;
  }

}
